import { PageAnchor } from 'src/app/AppAuth/PageAnchor'
import React, { useCallback, useMemo } from 'react'
import { ChatContextSourceType } from '@trustero/trustero-api-web/lib/chatcontext/chatcontext_pb'
import { ChatContext } from 'src/components/Reusable/ChatContext/useChatContext.hooks'
import { ChatContextBooleanSelector } from '../chatContextPanel.components'

export type SupportKnowledgeModalProps = {
  show: boolean
  hide: () => void
  onBack?: () => void
  context: ChatContext
  setContext: (context: ChatContext) => void
}

export const SupportKnowledgeModal = ({
  show,
  hide,
  onBack,
  context,
  setContext,
}: SupportKnowledgeModalProps): JSX.Element => {
  const onCommit = useCallback(
    (includeAll: boolean) => {
      setContext({
        ...context,
        [ChatContextSourceType.SUPPORT_KNOWLEDGE]: {
          ...context[ChatContextSourceType.SUPPORT_KNOWLEDGE],
          includeAll,
        },
      })
    },
    [context, setContext],
  )

  const description = useMemo(
    () => (
      <p>
        Select if you want to search Trustero&apos;s{' '}
        <PageAnchor
          href="https://support.trustero.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          support documentation
        </PageAnchor>{' '}
        for product usage guidance
      </p>
    ),
    [],
  )

  return (
    <ChatContextBooleanSelector
      title="Support Documentation"
      description={description}
      prompt="Do search support documentation"
      currentSelection={
        context[ChatContextSourceType.SUPPORT_KNOWLEDGE].includeAll
      }
      onCommit={onCommit}
      show={show}
      hide={hide}
      onBack={onBack}
    />
  )
}
